export default __webpack_public_path__ + "static/SuisseIntl-Medium-WebS-6d463bf21eeef8f34232131d28b8a001.eot";